import React, { MutableRefObject } from 'react';
import { ANIMATION_CONFIG } from '../config';
import s from '../Astro.module.css';

type DotTrailProps = {
  leadDotRef: MutableRefObject<HTMLDivElement | null>;
  trailRefs: MutableRefObject<(HTMLDivElement | null)[]>;
};

export const DotTrail = ({ leadDotRef, trailRefs }: DotTrailProps) => (
  <>
    <div
      ref={leadDotRef}
      className={s.leadDot}
      style={{
        width: ANIMATION_CONFIG.DOT_SIZE,
        height: ANIMATION_CONFIG.DOT_SIZE,
        background: ANIMATION_CONFIG.DOT_COLOR,
      }}
    />

    {Array.from({ length: ANIMATION_CONFIG.TRAIL_COUNT }).map((_, i) => (
      <div
        key={i}
        ref={(el) => (trailRefs.current[i] = el)}
        className={s.trailDot}
        style={{
          width: ANIMATION_CONFIG.DOT_SIZE,
          height: ANIMATION_CONFIG.DOT_SIZE,
          background: ANIMATION_CONFIG.DOT_COLOR,
          filter: ANIMATION_CONFIG.TRAIL_BLUR
            ? `blur(${ANIMATION_CONFIG.TRAIL_BLUR}px)`
            : 'none',
        }}
      />
    ))}
  </>
);
